export default __webpack_public_path__ + "static/emx-7e4622b43a89718dad23a1518f9791d3.svg";